/**
 * VÉRAULT Portal — small, focused formatters.
 * Pure functions; no React, no side-effects.
 */

export function money(value, currency = "USD") {
  if (value == null || isNaN(value)) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `$${Math.round(value).toLocaleString()}`;
  }
}

export function moneyExact(value, currency = "USD") {
  if (value == null || isNaN(value)) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format(value);
  } catch {
    return `$${value.toFixed(2)}`;
  }
}

/**
 * Parse a "YYYY-MM-DD" date string without timezone shift (the recurring bug
 * the handoff warned about). Local-noon trick preserves the calendar date.
 */
export function parseDateLocal(iso) {
  if (!iso) return null;
  if (iso instanceof Date) return iso;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  if (!m) return new Date(iso);
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0);
}

export function formatDate(iso, opts = { month: "short", day: "numeric", year: "numeric" }) {
  const d = parseDateLocal(iso);
  if (!d || isNaN(d)) return "";
  return d.toLocaleDateString("en-US", opts);
}

export function formatDateRange(startIso, endIso) {
  if (!startIso || !endIso) return formatDate(startIso || endIso);
  const a = parseDateLocal(startIso);
  const b = parseDateLocal(endIso);
  if (!a || !b) return "";
  const sameYear = a.getFullYear() === b.getFullYear();
  const sameMonth = sameYear && a.getMonth() === b.getMonth();
  const monthFmt = { month: "long" };
  if (sameMonth) {
    return `${a.toLocaleDateString("en-US", monthFmt)} ${a.getDate()}–${b.getDate()}, ${a.getFullYear()}`;
  }
  if (sameYear) {
    return `${a.toLocaleDateString("en-US", monthFmt)} ${a.getDate()} – ${b.toLocaleDateString("en-US", monthFmt)} ${b.getDate()}, ${a.getFullYear()}`;
  }
  return `${formatDate(startIso)} – ${formatDate(endIso)}`;
}

export function daysUntil(iso) {
  const d = parseDateLocal(iso);
  if (!d) return null;
  const now = new Date();
  now.setHours(12, 0, 0, 0);
  return Math.round((d - now) / 86400000);
}

export function initials(name) {
  if (!name) return "";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");
}
